import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

/** Sobre estándar del backend: { success, data, messages }. */
interface ApiEnvelope<T> {
  success: boolean;
  data: T | null;
  messages: string[];
}

/** Payload real de GET /api/me (ver MeGateway en el backend). */
interface MeData {
  username: string;
  nombreCompleto: string;
  roles: string[];
  tenant: { code: string; nombre: string };
}

export interface MeResponse {
  username: string;
  name: string;
  roles: string[];
  tenant: { code: string; nombre: string };
}

/**
 * GET /api/me — resolves the current user + tenant from the backend.
 * Falls back gracefully (query stays in error/empty) so the shell still renders.
 */
export function useMe() {
  const authenticated = useAuthStore((s) => s.authenticated);
  return useQuery({
    queryKey: ['me'],
    queryFn: async (): Promise<MeResponse> => {
      const res = await apiClient.get<ApiEnvelope<MeData>>('/me');
      if (!res.success || !res.data) throw new Error('sesión inválida');
      return {
        username: res.data.username,
        name: res.data.nombreCompleto,
        roles: res.data.roles ?? [],
        tenant: res.data.tenant,
      };
    },
    enabled: authenticated,
  });
}
